<div>
  <span class="card" [ngClass]="{ disabled: !isEditable }">
    <div class="method-list" *ngIf="showAllMethods && sortedMethods?.size > 0; else singlePaymentMethod">
      <ng-container *ngFor="let type of sortedMethods | keys; let firstKey = first">
        <p class="section-header" [class.remove-top-margin]="firstKey">{{ type | paymentTypeToTitle }}</p>
        <ng-container *ngFor="let paymentMethod of sortedMethods.get(type)">
          <div class="method-row">
            <span>
              <smb-invoicing-payment-method-display
                [paymentMethod]="paymentMethod"
              ></smb-invoicing-payment-method-display>
              <button
                mat-button
                type="button"
                class="use-default-button"
                *ngIf="isEditable && paymentMethod?.details?.id !== defaultPaymentMethod?.details?.id"
                color="primary"
                (click)="makePaymentMethodDefault(paymentMethod)"
              >
                {{ makeDefaultButton }}
              </button>
              <glxy-badge
                *ngIf="paymentMethod?.details?.id === defaultPaymentMethod?.details?.id"
                [color]="'blue'"
                class="default-badge"
              >
                {{ 'PAYMENT_METHOD_SELECTOR.DEFAULT' | translate }}
              </glxy-badge>
            </span>
            <button
              mat-icon-button
              type="button"
              *ngIf="canRemoveSelectedMethod || paymentMethod?.details?.id !== defaultPaymentMethod?.details?.id"
              (click)="deletePaymentMethod(paymentMethod)"
              title="remove"
              aria-label="remove"
            >
              <mat-icon class="remove-button">delete</mat-icon>
            </button>
          </div>
        </ng-container>
        <mat-divider></mat-divider>
      </ng-container>
      <button type="button" color="primary" mat-stroked-button (click)="addPaymentMethodDialog()">
        {{ addCardButton }}
      </button>
      <mat-hint>{{ hintText }}</mat-hint>
    </div>
    <ng-template #singlePaymentMethod>
      <ng-container *ngIf="defaultPaymentMethod; else emptyPaymentMethod">
        <smb-invoicing-payment-method-display
          [paymentMethod]="defaultPaymentMethod"
        ></smb-invoicing-payment-method-display>
        <button
          class="edit-button"
          mat-button
          type="button"
          *ngIf="isEditable"
          color="primary"
          (click)="openPaymentMethodDialog()"
        >
          {{ editButton }}
        </button>
        <div [ngClass]="{ 'edit-spacer': isEditable, spacer: !isEditable }"></div>
        <mat-hint>{{ hintText }}</mat-hint>
      </ng-container>
    </ng-template>
    <ng-template #emptyPaymentMethod>
      <div *ngIf="isEditable" class="col empty-card-layout">
        <span class="no-card-message">{{ emptyCardHintText }}</span>
        <button type="button" color="primary" mat-stroked-button (click)="openPaymentMethodDialog()">
          {{ addCardButton }}
        </button>
      </div>
    </ng-template>
  </span>
</div>
